package gr.tech.meetinggenie.models.meeting

enum class MEETING_STATUS(val short: Short, val label: String) {
    CLOSED(0, "Closed"),
    OPEN(1, "Open"),
    ARCHIVED(2, "Archived"),
    DELETED(3, "Deleted");

    companion object {
        fun parseStatus(status: Short?): MEETING_STATUS = when (status) {
            0.toShort() -> CLOSED
            1.toShort() -> OPEN
            2.toShort() -> ARCHIVED
            3.toShort() -> DELETED
            else        -> OPEN
        }
    }
}
